import React from 'react'
import Head from 'next/head'
import CommonHead from '../_head'
import Disclaimer from '../../src/pages/website/Disclaimer/Disclaimer'

export default () => (
  <>
    <Head>
      <title>Earnings and Income Disclaimer</title>
      <CommonHead />
    </Head>

    <Disclaimer />
  </>
)
